import { render } from "./KullanicilarDurum.vue?vue&type=template&id=3224a361"
import script from "./KullanicilarDurum.vue?vue&type=script&lang=js"
export * from "./KullanicilarDurum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__